<template>
  <div v-if="show" class="detail-layout">
    <div class="content-layout">
      <div>
        <span class="btn-back" @click="onBack">返回</span>
      </div>
      <div class="content">
        <div class="top">
          <div>
            <div class="title">{{ respData.title }}</div>
            <span class="info">{{ respData.city }} | {{ respData.workExperience }} | {{ respData.salary }} </span>
          </div>
          <span>{{ respData.pubDate }}</span>
        </div>
        <div class="line-h"></div>

        <div style="margin: 20px 0;" v-html="respData.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchRecruitmentDetail } from './model'
export default {
  data() {
    return {
      show: false,
      respData: {}
    }
  },
  methods: {
    onBack() {
      this.show = false
      this.$emit('onBack')
    },
    init(index, id) {
      this.show = true
      if (index === 0 && id) {
        this.getRecruitmentDetail(id)
      }
    },
    async getRecruitmentDetail(id) {
      const resp = await fetchRecruitmentDetail(id)
      this.respData = resp.data
    }
  }
}
</script>

<style lang="scss" scoped>
$margin-top: 4vh;
.detail-layout {
  display: flex;
  justify-content: center;
  width: 100%;
  .content-layout {
    display: flex;
    width: 80vw;
    height: calc(100vh - 90px);
    .btn-back {
      display: inline-block;
      border: 1px solid #999999;
      border-radius: 25px;
      padding: 10px 24px;
      margin: 20px;
      cursor: pointer;
      margin-top: $margin-top;

      &::before {
        content: '\e6de';
        font-family: 'element-icons';
      }
    }

    .content {
      flex: 1;
      padding: 0 40px 20px;

      .top {
        height: 100px;
        display: flex;
        justify-content: space-between;
        // align-items: center;
        margin-top: $margin-top;

        .title {
          color: #333;
          font-size: 30px;
          font-weight: bold;
        }
        .info {
          color: #333;
          font-size: 22px;
          line-height: 40px;
        }
      }
      // background: #999999;
    }
  }
}
</style>
